import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createInstance } from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { baseI18nOptions } from './i18n';
function createScopedInstance(locale) {
    const instance = createInstance();
    void instance.use(initReactI18next).init({
        ...baseI18nOptions,
        lng: locale.toLowerCase(),
        initImmediate: false,
    });
    return instance;
}
/**
 * Localizes a learner-preview subtree without changing the authoring app's
 * global i18n instance, document language, or persisted language preference.
 */
export function ScopedI18nProvider({ locale, children, }) {
    const [instance] = useState(() => createScopedInstance(locale));
    useEffect(() => {
        const normalizedLocale = locale.toLowerCase();
        if (instance.language !== normalizedLocale) {
            void instance.changeLanguage(normalizedLocale);
        }
    }, [instance, locale]);
    return _jsx(I18nextProvider, { i18n: instance, children: children });
}
//# sourceMappingURL=ScopedI18nProvider.js.map